module.exports = __webpack_public_path__ + "media/store/images/fincance-b5d79204da8001d2d1a676cfe9ece863.svg";